// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { jsonClass } from "@sumbricht/json-class-serializer";

const cache = new Map<string, any>();

export class $Config {
    static get Theme() {
        return {
            'theme': 'lowgile'
        }
    }

    static get Company() {
        return {
            'name': "Plastic Unlimited AG",
            'emailSignature': "<p><b>Plastic Unlimited AG</b></p>"
        }
    }
}
